import React, { useState, useEffect } from 'react';
import { useStore } from "../app/stores/store";
import LoginForm from '../features/users/LoginForm';

import { AiOutlineTrademark } from "@react-icons/all-files/ai/AiOutlineTrademark";
import { IoLocationOutline } from "@react-icons/all-files/io5/IoLocationOutline";
import { BsArrowRightShort } from "@react-icons/all-files/bs/BsArrowRightShort";
import { VscMail } from "react-icons/vsc";
import { BsTelephone } from "react-icons/bs";

import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import 'bootstrap/dist/css/bootstrap.min.css';
import "./Footer.css";

import logo from "../images/INAP.png";
import iconfa from "../../src/images/icon-fa.svg"
import iconin from "../../src/images/icon-in.svg"
import iconyo from "../../src/images/icon-you.svg"
import icontw from "../../src/images/icon-tw.svg"
import { Link } from 'react-router-dom';

const currentYear = new Date().getFullYear();

function Footer() {

  const { userStore: { isLoggedIn }, modalStore } = useStore();

  return (

    <>

      <Container fluid className="footer-area">

        <Row className="footer-rows">

          <Container className="call-area shadow">

          {isLoggedIn ?
            <>
              <Row>
                <Col lg="10" className="call-text" >
                  <h2>Felicidades, ¡Ya diste el primer paso!</h2>
                  <h3>Ahora es el momento, escoge e inscríbete hoy en uno de nuestros programas.</h3>
                </Col>
                <Col lg="2" className="call-button">
                  <Link to={"/certificaciones"}>
                    <Button
                    >
                      Ver cursos
                      <BsArrowRightShort />
                    </Button>

                  </Link>


                </Col>
              </Row>
            </> 
            :
            <>
              <Row>
                <Col lg="10" className="call-text" >
                  <h2>El mejor momento es ahora</h2>
                  <h3>Regístrate y da el primer paso para impulsar tu carrera profesional hoy mismo.</h3>
                </Col>
                <Col lg="2" className="call-button">

                  <Button
                    onClick={() => {
                      localStorage.removeItem('check');
                      localStorage.setItem('check', "false");
                      modalStore.openModal(<LoginForm />, "tiny" )
                    }} >Regístrate <BsArrowRightShort />
                  </Button>

                </Col>
              </Row>
            </>
          }


          </Container>

          <Container className="footer-body-area">
            <Row className="footer-body">

              <Col className="footer-b1">
                <Image src={logo}></Image>
              </Col>
              <Col className="footer-b2">
                <p className="icon-location"> <IoLocationOutline /> Boulevard los Próceres 16-40 Zona 10<br></br>Ciudad de Guatemala<br></br>Guatemala, Centroamérica</p>
                <p className="icon-phone"> <BsTelephone />Teléfono: 2419-8181</p>
                <p className="icon-mail"> <VscMail />Correo: informacion@inap.gob.gt</p>
              </Col>
              <Col className="footer-b3">
                <p>Síguenos en nuestras redes</p>
                <div className="footer-socials">
                  <Image src={iconfa} />
                  <Image src={iconin} />
                  <Image src={iconyo} />
                  <Image src={icontw} />
                </div>
              </Col>
            </Row>

            <div className="footer-divi"><span></span></div>

            <Row>
              <Col className="footer-rights">
                <p>INSTITUTO NACIONAL DE ADMINISTRACIÓN PÚBLICA - INAP <br></br> <AiOutlineTrademark /> Derechos reservados | INAP - Guatemala {currentYear}</p>
              </Col>
            </Row>
          </Container>

        </Row>
      </Container>

    </>

  );
}

export default Footer;
